/**
 * Coloured stat tile — pill label + big value + helper line.
 * Port of manuals/COP-microservice-integration/Datasets/stat-card.jsx
 * with the reference's `bg-*Soft` tokens mapped to coord's palette
 * (accent-soft, rose-soft, success-soft) plus standard Tailwind 50-shades
 * for tones that have no coord-level alias (emerald, amber, violet, etc).
 */
export function StatCard({ label, value, tone = 'default', icon, helper, details = [], compact = false, valueClassName }) {
  const toneClass =
    tone === 'accent'
      ? 'bg-accent-soft text-blue-700'
      : tone === 'success'
        ? 'bg-emerald-50 text-emerald-700'
        : tone === 'warning'
          ? 'bg-amber-50 text-amber-700'
          : tone === 'rose'
            ? 'bg-rose-soft text-rose-700'
            : tone === 'violet'
              ? 'bg-violet-100 text-violet-700'
              : tone === 'cyan'
                ? 'bg-cyan-100 text-cyan-700'
                : tone === 'indigo'
                  ? 'bg-indigo-100 text-indigo-700'
                  : tone === 'sky'
                    ? 'bg-sky-100 text-sky-700'
                    : tone === 'lime'
                      ? 'bg-lime-100 text-lime-700'
                      : tone === 'orange'
                        ? 'bg-orange-100 text-orange-700'
                        : tone === 'teal'
                          ? 'bg-teal-100 text-teal-700'
                          : 'bg-slate-100 text-slate-700';

  if (compact) {
    return (
      <div className="flex items-center gap-3 rounded-xl border border-line bg-white px-3 py-2.5 shadow-card">
        {icon ? <i className={`${icon} text-sm text-slate-400`} /> : null}
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-semibold uppercase tracking-wider text-mist">{label}</div>
          <div className="text-base font-semibold tracking-tight text-ink">{value}</div>
        </div>
        {helper ? <span className="text-[10px] text-mist whitespace-nowrap">{helper}</span> : null}
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-line bg-white p-4 shadow-card">
      <div className="mb-3 flex items-center justify-between gap-3">
        <div className={`inline-flex rounded-full px-3 py-1 text-xs font-semibold ${toneClass}`}>{label}</div>
        {icon ? <i className={`${icon} text-sm text-slate-500`} /> : null}
      </div>
      <div className={valueClassName || 'text-base font-semibold tracking-tight text-ink whitespace-nowrap'}>{value}</div>
      {helper ? <p className="mt-1 text-xs text-mist">{helper}</p> : null}
      {details.length ? (
        <div className="mt-3 space-y-1.5 text-xs text-mist">
          {details.map((detail) => (
            <div key={detail} className="truncate">
              {detail}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
